import { makeStyles } from "@material-ui/core";
import colors from "Styles/colors";

const useStyles = makeStyles({
  subSectionWrapper: {
    width: "45%",
  },
  term: {
    padding: "0 20px",
  },
  detail: {
    color: colors.black,
    float: "right",
    padding: "0 20px",
  },
  gridSection: {
    marginBottom: 16,
  },
  containerGrid: {
    display: "flex",
    justifyContent: "space-between",
  },
});

export default useStyles;
